<template>
    <div class="container-fluid form-container take-over-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Take Over Form
                </h1>
            </div>
        </div>

        <form
            action=""
            class="take-over-form"
            @submit.prevent="saveForm"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <label for="protected_area">Protected Area</label>
                            <textarea
                                name="protected_area"
                                id="protected_area"
                                rows="3"
                                class="form-control"
                                v-model="form.protected_area"
                                placeholder="Protected area..."
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label
                                for="job_id"
                                v-if="jobs"
                            >Job No.</label>
                            <select
                                v-if="jobs"
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="jobs.length < 1"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="attendance_date">Attendance Date</label>
                            <date-picker
                                type="text"
                                id="attendance_date"
                                name="attendance_date"
                                v-model="form.attendance_date"
                                class="top"
                                :options="{format: 'L'}"
                            />
                            <error
                                :errors="errors"
                                name="attendance_date"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                type="text"
                                id="po_number"
                                name="po_number"
                                v-model="form.po_number"
                                placeholder="Purchase Order No."
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="po_number"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <job-info
                v-if="form.job_id"
                :job-id="form.job_id"
            />

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>System Information / Documentation</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="system_manufacturer">Fire System Manufacturer</label>
                            <input
                                type="text"
                                v-model="form.system_manufacturer"
                                id="system_manufacturer"
                                name="system_manufacturer"
                                class="form-control"
                                placeholder="Manufacturer"
                            >
                            <error
                                name="system_manufacturer"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="system_model">Fire System Model</label>
                            <input
                                type="text"
                                v-model="form.system_model"
                                id="system_model"
                                name="system_model"
                                class="form-control"
                                placeholder="Model"
                            >
                            <error
                                name="system_model"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="system_protocol">Protocol</label>
                            <input
                                type="text"
                                v-model="form.system_protocol"
                                id="system_protocol"
                                name="system_protocol"
                                class="form-control"
                                placeholder="Protocol"
                            >
                            <error
                                name="system_protocol"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="system_model">System Type</label>
                            <input
                                type="text"
                                v-model="form.system_type"
                                id="system_type"
                                name="system_type"
                                class="form-control"
                                placeholder="Type"
                            >
                            <error
                                name="system_type"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="panel_networked">Panel Networked</label>
                            <select
                                v-model="form.panel_networked"
                                id="panel_networked"
                                name="panel_networked"
                                class="form-control"
                                placeholder="Protocol"
                            >
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                            <error
                                name="panel_networked"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_panels_network">No. of Panels on Network</label>
                            <select
                                v-model="form.no_panels_network"
                                id="no_panels_network"
                                name="no_panels_network"
                                class="form-control"
                            >
                                <option>0</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                                <option>9</option>
                                <option>10</option>
                            </select>
                            <error
                                name="no_panels_network"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="system_category">System Category</label>
                            <select
                                v-model="form.system_category"
                                id="system_category"
                                name="system_category"
                                class="form-control"
                            >
                                <option v-for="type in fire_alarm_systems">
                                    {{ type }}
                                </option>
                            </select>
                            <error
                                name="system_category"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_loops">No. of Loops</label>
                            <select
                                type="text"
                                v-model="form.no_loops"
                                id="no_loops"
                                name="no_loops"
                                class="form-control"
                            >
                                <option>0</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                            </select>
                            <error
                                name="no_loops"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_zones">No. of Zones (in use)</label>
                            <select
                                v-model="form.no_zones"
                                id="no_zones"
                                name="no_zones"
                                class="form-control"
                            >
                                <option>0</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                            </select>
                            <error
                                name="no_zones"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_repeater_panels">No. of Repeater Panels</label>
                            <select
                                v-model="form.no_repeater_panels"
                                id="no_repeater_panels"
                                name="no_repeater_panels"
                                class="form-control"
                            >
                                <option>0</option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                            </select>
                            <error
                                name="no_repeater_panels"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="min_battery_backup">Minimum Battery Backup Req. (H)</label>
                            <input
                                v-model="form.min_battery_backup"
                                id="min_battery_backup"
                                name="min_battery_backup"
                                class="form-control"
                                type="number"
                                step="1"
                                min="0"
                            >
                            <error
                                name="min_battery_backup"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="graphical_front">Graphical Front End Installed</label>
                            <select
                                v-model="form.graphical_front"
                                id="graphical_front"
                                name="graphical_front"
                                class="form-control"
                            >
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                            <error
                                name="graphical_front"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 form-group">
                            <label for="battery_backup_data_source">Source of Data for Battery Backup Requirement:</label>
                            <input
                                type="text"
                                v-model="form.battery_backup_data_source"
                                id="battery_backup_data_source"
                                name="battery_backup_data_source"
                                class="form-control"
                                placeholder="Type here..."
                            >
                            <error
                                name="battery_backup_data_source"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Fire System Quantities</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_mcp">No. of MCP</label>
                            <input
                                type="text"
                                v-model="form.no_mcp"
                                id="no_mcp"
                                name="no_mcp"
                                class="form-control"
                                placeholder="No. of MCP"
                            >
                            <error
                                name="no_mcp"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_other_detectors">No. of Other Detectors:</label>
                            <input
                                type="text"
                                v-model="form.no_other_detectors"
                                id="no_other_detectors"
                                name="no_other_detectors"
                                class="form-control"
                                placeholder="No. of Other Detectors"
                            >
                            <error
                                name="no_other_detectors"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_smoke_detectors">No. of Smoke Detectors</label>
                            <input
                                type="text"
                                v-model="form.no_smoke_detectors"
                                id="no_smoke_detectors"
                                name="no_smoke_detectors"
                                class="form-control"
                                placeholder="No. of Smoke Detectors"
                            >
                            <error
                                name="no_smoke_detectors"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_sounders">No. of Sounders</label>
                            <input
                                type="text"
                                v-model="form.no_sounders"
                                id="no_sounders"
                                name="no_sounders"
                                class="form-control"
                                placeholder="No. of Sounders"
                            >
                            <error
                                name="no_sounders"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_heat_detectors">No. of Heat Detectors</label>
                            <input
                                type="text"
                                v-model="form.no_heat_detectors"
                                id="no_heat_detectors"
                                name="no_heat_detectors"
                                class="form-control"
                                placeholder="No. of Heat Detectors"
                            >
                            <error
                                name="no_heat_detectors"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_strobes">No. of Strobes</label>
                            <input
                                type="text"
                                v-model="form.no_strobes"
                                id="no_strobes"
                                name="no_strobes"
                                class="form-control"
                                placeholder="No. of Strobes"
                            >
                            <error
                                name="no_strobes"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_aspirators">No. of Aspirators</label>
                            <input
                                type="text"
                                v-model="form.no_aspirators"
                                id="no_aspirators"
                                name="no_aspirators"
                                class="form-control"
                                placeholder="No. of Aspirators"
                            >
                            <error
                                name="no_aspirators"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_io_interfaces">No. of I/O Interfaces</label>
                            <input
                                type="text"
                                v-model="form.no_io_interfaces"
                                id="no_io_interfaces"
                                name="no_io_interfaces"
                                class="form-control"
                                placeholder="No. of I/O Interfaces"
                            >
                            <error
                                name="no_io_interfaces"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="pvva_system">PA/VA System Incorporated?</label>
                            <select
                                type="text"
                                v-model="form.pvva_system"
                                id="pvva_system"
                                name="pvva_system"
                                class="form-control"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select
                                </option>
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                            <error
                                name="pvva_system"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="pvva_manufacturer">PA/VA Manufacturer</label>
                            <input
                                type="text"
                                v-model="form.pvva_manufacturer"
                                id="pvva_manufacturer"
                                name="pvva_manufacturer"
                                class="form-control"
                                placeholder="PA/VA Manufacturer"
                            >
                            <error
                                name="pvva_manufacturer"
                                :errors="errors"
                            />

                            <label for="pvva_manufacturer">PA/VA Model</label>
                            <input
                                type="text"
                                v-model="form.pvva_model"
                                id="pvva_model"
                                name="pvva_model"
                                class="form-control"
                                placeholder="PA/VA Model"
                            >
                            <error
                                name="pvva_model"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 form-group">
                            <label for="pvva_system">PA/VA Device Quantities</label>
                            <input
                                type="text"
                                placeholder="0"
                                v-model="form.pvva_device_quantity"
                                id="pvva_device_quantity"
                                name="pvva_device_quantity"
                                class="form-control"
                            >
                            <error
                                name="pvva_device_quantity"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_amps">No. of AMPs</label>
                            <input
                                type="text"
                                placeholder="0"
                                v-model="form.no_amps"
                                id="no_amps"
                                name="no_amps"
                                class="form-control"
                            >
                            <error
                                name="no_amps"
                                :errors="errors"
                            />

                            <label for="no_mics">No. of MICs</label>
                            <input
                                type="text"
                                placeholder="0"
                                v-model="form.no_mics"
                                id="no_mics"
                                name="no_mics"
                                class="form-control"
                            >
                            <error
                                name="no_mics"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="no_speakers">No. of Speakers</label>
                            <input
                                type="text"
                                placeholder="0"
                                v-model="form.no_speakers"
                                id="no_speakers"
                                name="no_speakers"
                                class="form-control"
                            >
                            <error
                                name="no_speakers"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <h4>Remote Signalling</h4>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="remote_signalling_fire">Remote Signalling for Fire</label>
                            <select
                                v-model="form.remote_signalling_fire"
                                id="remote_signalling_fire"
                                name="remote_signalling_fire"
                                class="form-control"
                            >
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                            <error
                                name="remote_signalling_fire"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <label for="remote_signalling_account">Account Number</label>
                            <input
                                type="text"
                                placeholder="Account Number"
                                v-model="form.remote_signalling_account"
                                id="remote_signalling_account"
                                name="remote_signalling_account"
                                class="form-control"
                            >
                            <error
                                name="remote_signalling_account"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="remote_signalling_fault">Remote Signalling for Fault</label>
                            <select
                                v-model="form.remote_signalling_fault"
                                id="remote_signalling_fault"
                                name="remote_signalling_fault"
                                class="form-control"
                            >
                                <option>Yes</option>
                                <option>No</option>
                            </select>
                            <error
                                name="remote_signalling_fault"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <label for="remote_signalling_response">Key Holder or Brigade Response</label>
                            <select
                                v-model="form.remote_signalling_response"
                                id="remote_signalling_response"
                                name="remote_signalling_response"
                                class="form-control"
                            >
                                <option>Keyholder</option>
                                <option>Brigade</option>
                            </select>
                            <error
                                name="remote_signalling_response"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <select-row
                        v-model="form.control_panel_visible"
                        id="control_panel_visible"
                        label="Is the control panel clearly visible and accessible to the client?"
                    />

                    <select-row
                        v-model="form.om_manual"
                        id="om_manual"
                        label="Is an O&M manual available?"
                    />

                    <select-row
                        v-model="form.as_fitted_drawings"
                        id="as_fitted_drawings"
                        label="Does this include “as fitted” drawings?"
                    />

                    <select-row
                        v-model="form.cable_routing_recorded"
                        id="cable_routing_recorded"
                        label="Is the cable routing recorded on the “as fitted” drawings?"
                    />

                    <select-row
                        v-model="form.design_certificate"
                        id="design_certificate"
                        label="Is a design certificate available?"
                    />

                    <select-row
                        v-model="form.install_certificate"
                        id="install_certificate"
                        label="Is an install certificate available?"
                    />

                    <select-row
                        v-model="form.commissioning_certificate"
                        id="commissioning_certificate"
                        label="Is a commissioning certificate available?"
                    />

                    <select-row
                        v-model="form.variations_to_design"
                        id="variations_to_design"
                        label="Are there any variations to the original design documented?"
                    />

                    <select-row
                        v-model="form.bafe_certificate"
                        id="bafe_certificate"
                        label="Is a BAFE/SSAIB/NSI Certificate available?"
                    />

                    <div class="row">
                        <div class="col-sm-12 col-md-10">
                            <label for="certificate_number">Certificate Number:</label>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <input
                                type="text"
                                name="certificate_number"
                                id="certificate_number"
                                v-model="form.certificate_number"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <select-row
                        v-model="form.zone_plan"
                        id="zone_plan"
                        label="Is there a Zone Plan located adjacent to the Control Panel and does it comply with clause 23.2.2?"
                    />

                    <select-row
                        v-model="form.log_book_on_site"
                        id="log_book_on_site"
                        label="Is there a compliant system Log Book on site?"
                    />

                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <label for="log_book_location">Log book location:</label>
                        </div>
                        <div class="col-sm-12 col-md-8">
                            <input
                                type="text"
                                name="log_book_location"
                                id="log_book_location"
                                v-model="form.log_book_location"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-10">
                            <label for="false_alarms">Number of false alarms in last 12 months:</label>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <input
                                type="number"
                                min="0"
                                step="1"
                                name="false_alarms"
                                id="false_alarms"
                                v-model="form.false_alarms"
                                class="form-control"
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Design Suitability (8)</h3>
                        </div>
                    </div>

                    <select-row
                        v-model="form.protection_adequate"
                        id="protection_adequate"
                        label="Is the protection adequate according to the category selected?"
                    />

                    <div class="row">
                        <div class="col-sm-12">
                            <label for="design_suitability_details">Details</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <textarea
                                name="design_suitability_details"
                                id="design_suitability_details"
                                rows="5"
                                v-model="form.design_suitability_details"
                                placeholder="Details..."
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Hazardous Areas (10)</h3>
                        </div>
                    </div>

                    <select-row
                        v-model="form.hazardous_areas"
                        id="hazardous_areas"
                        label="Are there any hazardous areas with combustible dust or explosive gas protected?"
                    />

                    <div class="row">
                        <div class="col-sm-12">
                            <label for="hazardous_areas_details">Details</label>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <textarea
                                name="hazardous_areas_details"
                                id="hazardous_areas_details"
                                rows="5"
                                v-model="form.hazardous_areas_details"
                                placeholder="Details..."
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Actuation of other Facilities (Fire Alarm Cause an Effects) (9)</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <textarea
                                name="actuation_facilities_details"
                                id="actuation_facilities_details"
                                rows="5"
                                v-model="form.actuation_facilities_details"
                                placeholder="Details..."
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Main Connections (25:2)</h3>
                        </div>
                    </div>

                    <select-row
                        v-model="form.exclusive_supply"
                        id="exclusive_supply"
                        label="Is the supply exclusive to the fire alarm (from a distribution board isolator via a local double pole isolator)?"
                    />

                    <select-row
                        v-model="form.isolator_clearly_marked"
                        id="isolator_clearly_marked"
                        label="Is the distribution board isolator clearly marked “FIRE ALARM – DO NOT SWITCH OFF”?"
                    />

                    <select-row
                        v-model="form.secure_operation"
                        id="secure_operation"
                        label="Is it secure from unauthorised operation?"
                    />

                    <select-row
                        v-model="form.double_pole_isolator_marked"
                        id="double_pole_isolator_marked"
                        label="Is the local double pole isolator clearly marked “FIRE ALARM”?"
                    />

                    <select-row
                        v-model="form.fuse_rated"
                        id="fuse_rated"
                        label="Where fitted, is the fuse rating in the local double pole isolator in accordance with the CIE manufacturer’s recommendations?"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Fire System Cable and Cable Routing (26)</h3>
                        </div>
                    </div>

                    <select-row
                        v-model="form.correct_cable"
                        id="correct_cable"
                        label="Has the correct type of cable been utilised (i.e. fire rated) and segregated from extra low voltage cables?"
                    />

                    <select-row
                        v-model="form.cable_interference"
                        id="cable_interference"
                        label="Is the cabling run in areas not likely to suffer electrical interference?"
                    />

                    <select-row
                        v-model="form.cables_protected"
                        id="cables_protected"
                        label="Are the cables mechanically protected where susceptible to damage (mechanical and/or deliberate)?"
                    />

                    <select-row
                        v-model="form.cables_metal_casings"
                        id="cables_metal_casings"
                        label="Are cables passing through cut metal casings properly protected?"
                    />

                    <select-row
                        v-model="form.cables_penetrate_walls"
                        id="cables_penetrate_walls"
                        label="Where cables penetrate walls or floors, is there adequate fire stopping? (37.2)"
                    />

                    <select-row
                        v-model="form.cables_terminated"
                        id="cables_terminated"
                        label="Are cables correctly terminated and insulated using the appropriate glands?"
                    />

                    <select-row
                        v-model="form.fitted_batteries"
                        id="fitted_batteries"
                        label="Do the fitted batteries meet the stand-by requirements based upon the measured readings?"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Variations: (any areas of non-compliance/concern)</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <textarea
                                v-model="form.variations"
                                placeholder="Variations..."
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Notes: (any codes/keys/access requirements, etc.)</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <textarea
                                v-model="form.notes"
                                placeholder="Notes..."
                                class="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="customer_name">Customer name:</label>
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <input
                                type="text"
                                v-model="form.customer_name"
                                placeholder="First Name Last Name"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="customer_name">Customer position:</label>
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <input
                                type="text"
                                v-model="form.customer_position"
                                placeholder="Position"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p>
                                I/We being the competent person(s) responsible (as indicated by my/our name below) for the servicing of the fire alarm system, particulars of which are set out below, CERTIFY that the said work for which I/we have been responsible complies to the best of my/our knowledge and belief with the recommendations of Clause 46.2 of BS 5839-1 takeover of fire alarm systems, except for the variations, if any, stated in this certificate.
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="engineers_name">Engineer's name:</label>
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <input
                                type="text"
                                id="engineer_name"
                                v-model="form.engineer_name"
                                placeholder="Engineer's name"
                                class="form-control"
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isSaving || isLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isSaving || isLoading"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                                target="_blank"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit' && form.job_id"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import datePicker from "../DateTimePickerComponent.vue";
import CustomerSearch from "../CustomerSearch.vue";
import Service from "../../services/FormService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";
import JobService from "../../services/JobService";
import SelectRow from "./parts/SelectRowComponent";
import AuthService from "../../services/AuthService";
import FormService from "../../services/FormService";
import JobInfo from './parts/JobInfoComponent';
import {fire_alarm_systems} from "../../include/Form";

export default {
    components: {
        CustomerSearch,
        datePicker,
        SelectRow,
        JobInfo,
    },
    mixins: [UsesErrors, UsesInfoMessage, UsesFormRouteQuery],
    data() {
        return {
            form: {
                attendance_date: window.moment(),
                type: "take_over"
            },
            token: null,
            jobs: [],
            fire_alarm_systems,
        };
    },
    computed: {
        canDelete: function() {
            return (
                AuthService.user.admin_access || AuthService.user.office_access
            );
        }
    },
    mounted() {

        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then(res => {
                this.form.doc_no = res.data;
            });
        }

        if (!this.form.engineer_name) {
            const user = AuthService.user;
            if (user.engineer_access) {
                this.form.engineer_name = user.name;
            }
        }
    },
    methods: {
        loadForm: function(id) {
            this.setLoading();
            FormService.get(id)
                .then(res => {
                    this.form = res.data;
                    this.getJobs();
                })
                .catch(() => {
                    this.setErrorMessage("Could not load form");
                })
                .then(() => {
                    this.clearLoading();
                });
        },

        saveForm: function() {
            this.setSaving();

            let data = { ...this.form };
            delete data["customer"];
            delete data["site"];
            delete data["job"];
            delete data["data"];

            if (this.form.id) {
                Service.update(data)
                    .then(res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit("formSaved", res.data);
                    })
                    .catch(err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    });
            } else {
                Service.create(data)
                    .then(res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        if (this.$route.path.includes("engineer/")) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    })
                    .catch(err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    });
            }
        },

        deleteForm: function() {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    () => {
                        this.setInfoMessage("Form successfully deleted");
                        this.$router.push({ name: "office.forms.search" });
                    },
                    () => {
                        this.setErrorMessage("Could not delete this form");
                    }
                );
            }
        },

        customerChanged(customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                }
            } else {
                this.form.site_id = '';
            }
            this.getJobs();
        },

        getJobs() {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({
                "filter[customer_id]": this.form.customer_id
            }).then(
                res => {
                    this.jobs = res.data.data || [];
                },
                () => {
                    this.setErrorMessage("Could not load customer jobs");
                    this.jobs = [];
                }
            );
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/TakeOverFormComponent.vue